import { useState, useEffect } from "react";

/**
 * Tracks the OS "reduce motion" setting so JS-driven animation
 * (requestAnimationFrame loops, mousemove parallax) can be switched off too —
 * the CSS guard in GlobalStyles only covers CSS animations.
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(
    () => typeof window !== "undefined" &&
      window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
  );

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onChange = () => setReduced(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return reduced;
}
